export enum FooterItemPathEnum {
  SPEACH_ME = 'https://www.speach.me',
  ACCESSIBILITY = '/accessibility-statement',
  GCU = '/gcuContent',
  PDP = '/pdpContent',
}
